<template>
  <section class="hero-block" :id="anchorId">
      <figure v-if="heroImage" class="hero-image">
        <Image :filename="heroImage"   :context="kql.page" sizes="(max-width: 1200px) 100vw, 1200px" />
      </figure>
      <blockquote class="hero-intro"><Arrow /> {{ data.content.intro }}</blockquote>
  </section>
</template>

<script setup>
import { useStore } from '@/KQL.js'
import Image from '@/components/Media/Image.vue'
import { useAnchorId } from '@/composables/useAnchorId';

const kql = useStore()

const props = defineProps({
  data: {
    type: Object,
    required: true
  }
});

const anchorId = useAnchorId(toRef(props, 'data'));

const heroImage = computed(() => {
  const image = props.data.content.image;
  if (!image) return null;
  return Array.isArray(image) ? image[0] : image;
});
</script>

<style scoped>
@import '@/css/breakpoints.css';

  section {
    max-width: var(--main-width);
    margin-inline: var(--main-margin);
    overflow-x: hidden;
    border-radius: 4.25rem;
    background: var(--white);
    padding: 0;
    container-type: inline-size;
    overflow: hidden;
    color: var(--dark);
  }

  figure {
    overflow: hidden;
    width: 100%;
    max-height: 41.5rem;
  }

  @media (--phone) {
    figure {
      min-height: 30rem;
    }

    figure :deep(img) {
      min-height: 30rem;
    }
  }

  blockquote {
    margin: 2.75rem 7cqw 7.5rem;
    font-size: var(--text-4xl);
    font-family: var(--font-serif);
    line-height: var(--leading-snug);
    letter-spacing: var(--tracking-tight);
  }
</style>
